import React, { useCallback } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import { actions as themeActions } from 'slices/themes';
import SidebarNavItems from './SidebarNavItems';
import { useDispatch, useSelector } from 'react-redux';
import { themeNames } from 'theme/base';
import isEmpty from 'lodash/isEmpty';
import { getCompanyThemes } from 'reducers/securityCompany';
import { ThemeIcon } from 'Icons';

const { setGlobalTheme } = themeActions;

const SidebarNav = props => {
  // eslint-disable-next-line react/prop-types
  const { isCollapsed, menuMain } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const themes = useSelector(state => getCompanyThemes(state));
  // change the theme
  const changeTheme = useCallback(
    mode => {
      dispatch(setGlobalTheme(mode));
    },
    [dispatch],
  );

  const menuTheme = (themes = []) => {
    if (isEmpty(themes)) {
      return [];
    }
    const items = themes.map(i => {
      switch (i) {
        case themeNames.SECURITY.id:
          return {
            name: themeNames.SECURITY.name,
            themeID: themeNames.SECURITY.id,
            changeThemeCb: mode => changeTheme(mode),
          };
        case themeNames.CLEANING.id:
          return {
            name: themeNames.CLEANING.name,
            themeID: themeNames.CLEANING.id,
            changeThemeCb: mode => changeTheme(mode),
          };
        case themeNames.MAINTENANCE.id:
          return {
            name: themeNames.MAINTENANCE.name,
            themeID: themeNames.MAINTENANCE.id,
            changeThemeCb: mode => changeTheme(mode),
          };
        case themeNames.DARK.id: // default free theme
          return {
            name: themeNames.DARK.name,
            themeID: themeNames.DARK.id,
            changeThemeCb: mode => changeTheme(mode),
          };
        default:
          return null;
      }
    });
    if (isEmpty(items) || items.length < 2) {
      return [];
    }
    return [
      {
        subMenu: 'Themes',
        Icon: ThemeIcon,
        items: items,
      },
    ];
  };
  return (
    <div>
      <List className={classes.navList} disablePadding>
        {/* {!isCollapsed && (
          <ListSubheader disableSticky={true} className={classes.navListHeader}>
            Applications
          </ListSubheader>
        )} */}
        <SidebarNavItems isCollapsed={isCollapsed} items={menuMain} />
      </List>

      <List className={classes.navList} disablePadding>
        {/* {!isCollapsed && (
          <ListSubheader disableSticky={true} className={classes.navListHeader}>
            Themes
          </ListSubheader>
        )} */}
        <SidebarNavItems isCollapsed={isCollapsed} items={menuTheme(themes)} />
      </List>
    </div>
  );
};

const useStyles = makeStyles(theme =>
  createStyles({
    navList: {
      width: theme?.sidebar?.width,
      fontSize: '1.1em',
      fontWeight: 400,
      lineHeight: 1.5,
      letterSpacing: '0.00938em',
    },
    navListHeader: {
      textAlign: 'center',
    },
    iconFeatures: {
      color: '#95de3c',
    },
    iconDocs: {
      color: '#f8cda9',
    },
    iconSupporters: {
      color: '#e3b546',
    },
    iconDiscuss: {
      color: '#ccc',
    },
  }),
);

export default SidebarNav;
